module.exports = __webpack_public_path__ + "fd5697c2c555007a3a6722f72e6f1391.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_5_a.png
// module id = 78
// module chunks = 0